// extracted by mini-css-extract-plugin
module.exports = {"cont":"TVDisplay_cont__m8_Ni","post":"TVDisplay_post__tfG08","left2":"TVDisplay_left2__knBGO","right":"TVDisplay_right__O_L0B"};